import { ApiService } from './api/api'

export default class DriverService {
	private launchpadService
	private middlewareService

	constructor() {
		this.launchpadService = new ApiService(false, '2')
		this.middlewareService = new ApiService(true)
	}

	/**
	 * Get all operators at a depot
	 * @param depot string
	 * @returns Promise
	 */
	getAllByDepot(depot: string): Promise<any> {
		return this.launchpadService.get(`/driver/${depot}`)
	}

	/**
	 * Driver App: Confirm vehicle selection
	 * @param vehicle_registration string
	 * @returns Promise
	 */
	confirmVehicle(vehicle_registration: string): Promise<any> {
		return this.middlewareService.patch(`/service/driver-app/confirm-vehicle`, {
			vehicle_registration
		})
	}

	/**
	 * Driver App: Remove/Cancel vehicle selection
	 * @param vehicle_registration string
	 * @returns Promise
	 */
	removeVehicle(vehicle_registration: string): Promise<any> {
		return this.middlewareService.patch(`/service/driver-app/remove-vehicle`, {
			vehicle_registration
		})
	}
}
